import React from 'react';

import { DocumentViewerActions, DocumentViewerContext } from '@contexts/index';

import type { Document } from '@models/document';

export function useDocumentViewer() {
  const context = React.useContext(DocumentViewerContext);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context === undefined) {
    throw new Error(
      `useDocumentViewer must be used within a DocumentViewerProvider`
    );
  }

  const { state, dispatch } = context;

  const reset = () => {
    dispatch({ type: DocumentViewerActions.Reset });
  };

  const viewDocument = (document: Document) => {
    dispatch({
      type: DocumentViewerActions.View,
      document,
    });
  };

  return { state, dispatch, reset, viewDocument };
}
